module.exports = __webpack_public_path__ + "img/GitHub-Logo_edit.af5b07d4.png";